import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-metal-order-btn',
    imports: [RouterLink, RouterLinkActive, TranslateModule],
    templateUrl: './metal-order-btn.component.html',
    styleUrl: './metal-order-btn.component.css',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MetalOrderBtnComponent {}
